import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { theme } from "styles/MuiTheme";
import { useDispatch, useSelector } from "react-redux";
import PrivateRoute from "modules/Auth/components/PrivateRoute/PrivateRoute";
import Login from "modules/Auth/views/Login";
import MainRouter from "modules/MainRouter";
import {
  selectIsSessionConfirmed,
  selectLogInStatus,
} from "store/session/selectors";
import { initSession } from "store/session/thunks";
import { SessionStatus } from "types/Session";
import Loader from "components/Loader/Loader";
import RoleDetails from "modules/RolesManagement/views/RoleDetails";

function App() {
  const dispatch = useDispatch();
  const sessionStatus = useSelector(selectLogInStatus);
  const hasSessionBeenChecked = useSelector(selectIsSessionConfirmed);

  const dispatchSession = () => {
    if (!hasSessionBeenChecked) {
      dispatch(initSession());
    }
  };

  useEffect(dispatchSession, [hasSessionBeenChecked, sessionStatus]);

  if (sessionStatus === SessionStatus.initial) {
    return <Loader show />;
  }

  return (
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <Router>
          <Routes>
            <Route Component={Login} path="/login" />
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <MainRouter />
                </PrivateRoute>
              }
            />
            {/* Routes Without Header component */}
            <Route path="/RolesManagement/:roleId" element={<RoleDetails />} />
            <Route path="/RolesManagement/New" element={<RoleDetails />} />
          </Routes>
        </Router>
      </StyledEngineProvider>
    </ThemeProvider>
  );
}

export default App;
